<mat-list>
  <mat-list-item *ngFor="let item of items">
    <h4 mat-line>
      <b>{{ item.key }}</b>
    </h4>
    <p mat-line>
      <small>
        {{ item.value }}
      </small>
    </p>
  </mat-list-item>
</mat-list>
